<div class="flex flex-col flex-auto min-w-0">
    <div class="sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">
        <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between pb-8 px-6 md:px-8 border-b ">
            <div class="text-4xl font-extrabold tracking-tight">Fiches de l'interventions</div>
            <div class="flex shrink-0 items-center sm:ml-4">
                <button [routerLink]="['/dossiers-interventions', currentDossierIntervention.id, 'fiches-interventions', '0']" class="ml-4" mat-flat-button [color]="'primary'">
                    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    <span class="ml-2 mr-1">Ajouter</span>
                </button>
            </div>
        </div>

        <div class="flex flex-auto overflow-hidden">
            <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                <div class="grid">
                    <div class="table-grid-fiches-interventions z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <div>Date de contact</div>
                        <div>Date d'intervention</div>
                        <div>Catégorie d'intervention</div>
                        <div>Contenu rapporté Urgex</div>
                        <div class="right-0">Détail</div>
                    </div>
                    <ng-container *ngFor="let ficheIntervention of fichesInterventions; trackBy: trackByFn">
                        <div class="table-grid-fiches-interventions grid items-center gap-4 py-3 px-6 md:px-8 border-b">
                            <div class="">{{ficheIntervention.date_contact}}</div>
                            <div class="">{{ficheIntervention.date_intervention}}</div>
                            <div class="">{{ficheIntervention.categorie_intervention}}</div>
                            <div class="">{{ficheIntervention.contenu_rapporte_urgex}}</div>
                            <div class="right-0">
                                <a [routerLink]="['/dossiers-interventions', currentDossierIntervention.id, 'fiches-interventions', ficheIntervention.id]" class="min-w-10 min-h-7 h-7 px-2 leading-6" mat-stroked-button>
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
                                </a>
                                <button class="min-w-10 min-h-7 h-7 px-2 leading-6" mat-stroked-button (click)="delete(ficheIntervention.id)" *ngIf="isAdmin">
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                </button>
                            </div>
                        </div>
                        <div class="grid">
                            <ng-container *ngIf="currentDossierIntervention?.id === ficheIntervention.id">
                                <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: {$implicit: ficheIntervention}"></ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
